import { Component, Input } from '@angular/core';
import { SafePipe } from '../../pipes/safe.pipe';


@Component({
    selector: 'app-bottom-text',
    templateUrl: './bottom-text.component.html',
    styleUrls: ['./bottom-text.component.scss'],
    imports: [SafePipe]
})
export class BottomTextComponent {

  @Input('text') text: string;

  constructor() { }

}
